import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyTradeRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/trades/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/pharmacy/Trades/TradePage/TradePage').then((d) => d.Route));
